import { storeSession } from '@/generated/stores';
import routes from "@/router/appRoutes";
import { isMobile } from '@/style/StyleHelpers';
import { Modules } from '@/generated/classes/AppSchema';
import ShortUrl from '@/generated/classes/ShortUrl';
import { goToModule, CiRouter } from '@/framework/base/helpers/NavHelper';
import { Alerts } from '@/framework/base/helpers/Alerts';
import { createRouter, createWebHistory } from 'vue-router'
import Sso from "@/generated/classes/Sso";

const router = createRouter({
  history: createWebHistory(),
  routes,
})

let redirect = '';
let ssoAuthen = '';
router.beforeEach(async (to, from, next) => {
  const session = await storeSession;
  const isLoggedIn = session.sessionValid && session.logged;
  const key = to.path.replace("/", "").toUpperCase();
  try {
    if (from.params && from.params.route) {
      // @ts-expect-error : generated method
      if (from.params.route.updated && (from.params.route.error || from.params.route.missing)) {
        const res = await Alerts.cancelRoute();
        if (res) {
          throw new Error("Navigation aborted");
        }
      }
    }

    if (!isLoggedIn) {
      if (to.path == '/freshdesk') {
        ssoAuthen = to.fullPath;
        next({ name: 'Login' });
      }

      if (to.path === '/signed') {
        next();
      }

      if (to.path === '/payment-status') {
        next();
      }
      
      if (to.path !== "/subscribe" && to.path !== "/login" && to.path !== "/freshdesk" && to.path !== "/" && redirect == "") {
        redirect = to.path.replace("/", "");
        const shortUrl = await ShortUrl.shortUrlRoute(to.path.replace("/", ""));
        if (shortUrl.id && shortUrl.token && shortUrl.id > 0 && shortUrl.token != '') {
          storeSession.openSession(shortUrl.token)
            .then(() => {
              CiRouter.addRoute(shortUrl.route);
              next({ name: 'Dashboard' });
            })
        } else if (shortUrl.id && shortUrl.ident) {
          next({ name: 'HomePage', query: { ident: shortUrl.ident } });
        } else {
          next({ name: 'HomePage' });
        }
      } else {
        next();
      }
    } else {

      if (to.path === '/signed') {
        next();
      }

      if (to.path === '/payment-status') {
        next();
      }

      if (to.path == '/freshdesk' || ssoAuthen != '') {
        if (ssoAuthen == '') {
          ssoAuthen = to.fullPath;
        }
        const sso = new Sso();
        sso.param = ssoAuthen;
        Sso.authen(sso).then((url: string) => {
          window.location.replace(url);
        });
      }
      else if (redirect == "" && ((Object.values(Modules).includes(key as Modules)) || to.name == "Dashboard" || to.name == 'HomePage')) {
        if (to.name == 'Dashboard' && isMobile()) {
          next({ name: 'notification' });
        } else if (to.name == 'HomePage') {
          next({ name: 'Dashboard' });
        } else {
          next();
        }
      } else if (redirect != "") {
        ShortUrl.shortUrlRoute(redirect).then((res) => {
          if (res.id > 0 && !res.error) {
            if (!res.token) {
              goToModule(router, res.route);
            } else {
              next({ name: 'Dashboard' });
            }
            if (res.route.isDialog) {
              CiRouter.addRoute(res.route);
            }
          } else {
            next({ name: 'Dashboard' });
          }
        })
        redirect = "";
      } else {
        ShortUrl.shortUrlRoute(to.path.replace("/", "")).then((res) => {
          if (res && res.id > 0 && !res.error) {
            if (!res.token) {
              goToModule(router, res.route);
            }
            if (res.route.isDialog) {
              CiRouter.addRoute(res.route);
            }
          } else {
            next({ name: 'Dashboard' });
          }
        })
      }
    }
  } catch
  (error) {
    // Abort navigation
  }
}
)

export default router;
